export const businessConstants = {
	SEND_BUSINESS_REQUEST: "SEND_BUSINESS_REQUEST",
	SEND_BUSINESS_SUCCESS: "SEND_BUSINESS_SUCCESS",
	SEND_BUSINESS_ERROR: "SEND_BUSINESS_ERROR",
};